export default __webpack_public_path__ + "static/media/fond-arrondi-blanc-gauche.0b282d26.webp";